export default __webpack_public_path__ + "static/media/retro-beer-festival.076176ca.jpg";